import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Typography,
} from "@mui/material";
import { TextFieldDisabled } from "./TextFieldDisabled";
import { StatusIcon } from "./StatusIcon";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import { useNavigate } from "react-router-dom";
function UPSEItem({
  id,
  nombre,
  anio,
  responsable,
  cooperacion,
  lugar,
  techo,
  tipoEje,
  eje,
  estrategico,
  operativo,
}) {
  const navigate = useNavigate();
  const UPSEItem = () => {
    navigate("/UPSE1", { state: { id: id } });
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row", marginTop: 12 },
      }}
      className="bordered-box"
    >
      <Grid container>
        <Grid item xs={12} sm={3}>
          <Grid sx={{ display: "flex", flexDirection: "column" }} container>
            <Grid item xs={12}>
              <TextFieldDisabled title="Nombre" value={nombre} />
            </Grid>
            <Grid item xs={12}>
              <TextFieldDisabled title="Responsable" value={responsable} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Grid sx={{ display: "flex", flexDirection: "row" }} container>
            <Grid item xs={12}>
              <TextFieldDisabled title="Año que planifica" value={anio} />
            </Grid>
            <Grid item xs={12}>
              <TextFieldDisabled
                title="Techo presupuestario"
                value={techo}
                initialSign="Q"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Grid item xs={12}>
            <TextFieldDisabled title="Tipo de eje" value={tipoEje} />
          </Grid>
          <Grid item xs={12}>
            <TextFieldDisabled title="Eje" value={eje} />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                padding: "16.5px 14px",
              }}
            >
              <Typography variant="overline">Cooperación Externa</Typography>
              <StatusIcon value={cooperacion} />
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Box sx={{ paddingTop: "32px" }}>
              <IconButton
                className=""
                color="primary"
                sx={{ borderRadius: 0 }}
                onClick={() => UPSEItem()}
                onContextMenu={() => UPSEItem()}
              >
                <InfoTwoToneIcon />
                Ir al elemento
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={0}>
          <Divider />
        </Grid>
      </Grid>
    </Container>
  );
}
export { UPSEItem };
